import axios from 'axios';

export const $http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Brand: process.env.VUE_APP_BRAND_ID,
  },
});

class API {
  setToken(token) {
    if (!token) {
      return delete $http.defaults.headers.common.Authorization;
    }

    $http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  get(url, params) {
    params = params || {};
    return $http.get(url, params);
  }

  post(url, params) {
    params = params || {};
    return $http.post(url, params);
  }

  put(url, params) {
    params = params || {};
    return $http.put(url, params);
  }

  patch(url, params) {
    params = params || {};
    return $http.patch(url, params);
  }

  delete(url, params) {
    params = params || {};
    return $http.delete(url, params);
  }
}

export const APIHelper = new API();
